import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import {
  Description,
  CheckCircleOutline,
  AccessTime,
  // ForwardToInbox, 
  ErrorOutline,
  CalendarToday,
  // SupervisorAccount 
} from '@mui/icons-material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import toast from 'react-hot-toast';
import { ActionMenuProps } from './types';

/**
 * ActionMenu - Context menu for inspection actions
 */
const ActionMenu: React.FC<ActionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  inspection,
  onViewDetails,
  onComplete,
  onUpdateStatus,
}) => {
  if (!inspection) return null;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem onClick={() => onViewDetails(inspection)}>
        <Description fontSize="small" sx={{ mr: 1 }} /> View Details
      </MenuItem>

      {/* {(inspection.status === 'Scheduled' || inspection.status === 'Rescheduled') && (
        <MenuItem 
          onClick={() => {
            onClose();
            onComplete(inspection, false);
          }}
        >
          <CheckCircleOutline fontSize="small" sx={{ mr: 1 }} /> Mark as Complete
        </MenuItem>
      )} */}

      {(inspection.status === 'Scheduled' || inspection.status === 'Rescheduled') && (
        <MenuItem
          onClick={() => {
            onUpdateStatus(inspection?.inspectionId, 'In Progress');
            onClose();
          }}
        >
          <AccessTime fontSize="small" sx={{ mr: 1 }} /> Start Inspection
        </MenuItem>
      )}

      {inspection.status === 'InProgress' && (
        <MenuItem
          onClick={() => {
            onClose();
            onComplete(inspection, false);
          }}
        >
          <CheckCircleOutline fontSize="small" sx={{ mr: 1 }} /> Complete
        </MenuItem>
      )}

      <MenuItem onClick={() => {
        // Logic to add notes
        // toast.error('Add notes feature would open here');
        onClose();
        onComplete(inspection, false, true);
      }}>
        <WarningAmberIcon fontSize="small" color='warning' sx={{ mr: 1 }} /> Not Completed
      </MenuItem>

      {/* <MenuItem onClick={() => {
        // Logic to contact applicant
        toast.error('Contact applicant feature would open here');
        onClose();
      }}>
        <ForwardToInbox fontSize="small" sx={{ mr: 1 }} /> Contact Applicant
      </MenuItem> */}

      <MenuItem onClick={() => {
        // Logic to report issue
        onComplete(inspection, true)
        // onUpdateStatus(inspection.id, 'issue');
        // toast.error('Issue reported successfully');
        // onClose();
      }}>
        <ErrorOutline fontSize="small" sx={{ mr: 1 }} color="error" /> Report Issue
      </MenuItem>

      {inspection.status === 'issue' && (
        <MenuItem onClick={() => {
          // Logic to reschedule
          toast.success('Rescheduling process initiated');
          onClose();
        }}>
          <CalendarToday fontSize="small" sx={{ mr: 1 }} color="warning" /> Reschedule
        </MenuItem>
      )}

      {/* <MenuItem onClick={() => {
        // Logic to reassign
        toast.error('Request reassignment feature would open here');
        onClose();
      }}>
        <SupervisorAccount fontSize="small" sx={{ mr: 1 }} /> Request Reassignment
      </MenuItem> */}
    </Menu>
  );
};

export default ActionMenu;